module.exports = __webpack_public_path__ + "static/footerCooperBg.549319e0.jpg";